import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=ba5384cc"
import script from "./checklist.vue?vue&type=script&lang=js"
export * from "./checklist.vue?vue&type=script&lang=js"
import style0 from "./checklist.vue?vue&type=style&index=0&id=ba5384cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports